import { render } from "./AppFakeCheckBoxColor.vue?vue&type=template&id=5784a63c&scoped=true"
import script from "./AppFakeCheckBoxColor.vue?vue&type=script&lang=js"
export * from "./AppFakeCheckBoxColor.vue?vue&type=script&lang=js"

import "./AppFakeCheckBoxColor.vue?vue&type=style&index=0&id=5784a63c&scoped=true&lang=scss"

import exportComponent from "/var/www/web-love.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784a63c"]])

export default __exports__